















import Vue from "vue";

import IconMuscular from "@joyz/app-core/assets/icons/white/Muscular.svg";
import IconRetry from "@joyz/app-core/assets/icons/transparent/Retry.svg";

import { DrillState, ExerciseType } from "@tt-app/models/exercise";
import { getDrillTypeIcon } from "@tt-app/utils";

interface Computed {
  drillIcon: string;
}

interface Props {
  attemptCount: number;
  drill: DrillState;
  exerciseType: ExerciseType;
  practiceMode: boolean;
}

interface Data {
  icons: { [key: string]: string };
}

export default Vue.extend<Data, {}, Computed, Props>({
  name: "DrillProgress",

  props: {
    attemptCount: { type: Number, default: 1 },
    drill: { type: Object as () => DrillState, required: true },
    exerciseType: { type: Number as () => ExerciseType, required: true },
    practiceMode: { type: Boolean, default: false }
  },

  data() {
    return {
      icons: {
        muscular: IconMuscular,
        retry: IconRetry
      }
    };
  },

  computed: {
    drillIcon() {
      return this.practiceMode ? this.icons.muscular : getDrillTypeIcon(this.exerciseType);
    }
  }
});
